module.exports = ["en", "fr", "es", "de", "pt", "nl", "ja", "id", "zh"];
